import { render } from "./ConnectionTabsRenderer.vue?vue&type=template&id=acaaac60&scoped=true"
import script from "./ConnectionTabsRenderer.vue?vue&type=script&lang=js"
export * from "./ConnectionTabsRenderer.vue?vue&type=script&lang=js"

import "./ConnectionTabsRenderer.vue?vue&type=style&index=0&id=acaaac60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acaaac60"]])

export default __exports__